import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import {
  getScrollDepthPercent,
  getScrollThresholds,
  trackClickFromElement,
  trackScrollDepth,
  trackVirtualPageView,
} from '../../lib/analytics';

export function useSiteAnalytics(): void {
  const location = useLocation();
  const pagePath = `${location.pathname}${location.hash}`;
  const reachedScrollDepths = useRef<Set<number>>(new Set());

  useEffect(() => {
    reachedScrollDepths.current.clear();
    trackVirtualPageView(pagePath, document.title);
  }, [pagePath]);

  useEffect(() => {
    function handleScroll() {
      const depth = getScrollDepthPercent();

      for (const threshold of getScrollThresholds()) {
        if (depth >= threshold && !reachedScrollDepths.current.has(threshold)) {
          reachedScrollDepths.current.add(threshold);
          trackScrollDepth(threshold, pagePath);
        }
      }
    }

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pagePath]);

  useEffect(() => {
    function handleClick(event: MouseEvent) {
      trackClickFromElement(event.target, pagePath);
    }

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, [pagePath]);
}
